import type { StyleProp, TextInputProps, TextStyle, ViewStyle } from "react-native";
import { MaskType } from "../../helpers";

export type InputProps = TextInputProps & {
  asButton?: boolean;
  containerStyle?: StyleProp<TextStyle | ViewStyle>;
  error?: Maybe<string | boolean>;
  inputStyle?: StyleProp<TextStyle>;
  label?: string;
  maxCharacters?: number;
  onBlur?: NotWorth;
  onChangeText?: (text: string) => void;
  onFocus?: NotWorth;
  placeholderTextColor?: string;
  prefixComponent?: () => NotWorth;
  required?: boolean;
  showAnimatedLabel?: boolean;
  showErrorPlaceholder?: boolean;
  suffixComponent?: () => NotWorth;
  translateLabelX?: number;
  value: string;
} & (
    | {
        mask?: Omit<MaskType, "PostalCode">;
      }
    | { mask?: MaskType.PostalCode; countryCode: string }
  );

export enum MaxLength {
  BankAccount = 32,
  CardNumber = 19,
  PhoneNumber = 15,
  PostalCode = 6,
}
